import type { MutaFormulaGroup, MutaProductVersionFormat } from './model.ts'

export const mutaProductVersions = [
  /**
   * Initial version.
   */
  'product-fr-mut-acheel-1.0.0-2026-03-13',
  /**
   * Minor iteration : change on general terms
   */
  'product-fr-mut-acheel-1.1.0-2026-06-22',
  /**
   * Payment-method restriction applies only from this version onwards, protecting
   */
  'product-fr-mut-acheel-1.2.0-2026-08-05',
] as const satisfies MutaProductVersionFormat[]
export type MutaProductVersion = (typeof mutaProductVersions)[number]

export const mutaCgRefByProductVersionAndFormulaGroup = {
  'product-fr-mut-acheel-1.0.0-2026-03-13': {
    ESSENTIEL: '20230601-ESS-V1',
    PRIVILEGE: '20230601-PRI-V1',
  },
  'product-fr-mut-acheel-1.1.0-2026-06-22': {
    ESSENTIEL: '20260601-ESS-V1',
    PRIVILEGE: '20260601-PRI-V1',
  },
  'product-fr-mut-acheel-1.2.0-2026-08-05': {
    ESSENTIEL: '20260601-ESS-V1',
    PRIVILEGE: '20260601-PRI-V1',
  },
} as const satisfies Record<MutaProductVersion, Record<MutaFormulaGroup, string>>

export function getMutaCgRef(mutaFormulaGroup: MutaFormulaGroup, mutaProductVersion: MutaProductVersion): string {
  return mutaCgRefByProductVersionAndFormulaGroup[mutaProductVersion][mutaFormulaGroup]
}

export const mutaDocumentsByProductVersionAndFormulaGroup = {
  'product-fr-mut-acheel-1.0.0-2026-03-13': {
    ESSENTIEL: [
      {
        fileName: 'Orus - Notice valant Conditions générales Mutuelle.pdf',
        id: 'muta-esse-general-terms',
      },
      {
        fileName: 'Orus - IPID Mutuelle.pdf',
        id: 'muta-ipid',
      },
      {
        fileName: 'Orus - Status ACPA.pdf',
        id: 'muta-statuts-asso',
      },
    ],
    PRIVILEGE: [
      {
        fileName: 'Orus - Notice valant Conditions générales Mutuelle.pdf',
        id: 'muta-priv-general-terms',
      },
      {
        fileName: 'Orus - IPID Mutuelle.pdf',
        id: 'muta-ipid',
      },
      {
        fileName: 'Orus - Status ACPA.pdf',
        id: 'muta-statuts-asso',
      },
    ],
  },
  'product-fr-mut-acheel-1.1.0-2026-06-22': {
    ESSENTIEL: [
      {
        fileName: 'Orus - Notice valant Conditions générales Mutuelle.pdf',
        id: 'muta-esse-general-terms-v2',
      },
      {
        fileName: 'Orus - IPID Mutuelle.pdf',
        id: 'muta-ipid-v2',
      },
      {
        fileName: 'Orus - Status ACPA.pdf',
        id: 'muta-statuts-asso',
      },
    ],
    PRIVILEGE: [
      {
        fileName: 'Orus - Notice valant Conditions générales Mutuelle.pdf',
        id: 'muta-priv-general-terms-v2',
      },
      {
        fileName: 'Orus - IPID Mutuelle.pdf',
        id: 'muta-ipid-v2',
      },
      {
        fileName: 'Orus - Status ACPA.pdf',
        id: 'muta-statuts-asso',
      },
    ],
  },
  'product-fr-mut-acheel-1.2.0-2026-08-05': {
    ESSENTIEL: [
      {
        fileName: 'Orus - Notice valant Conditions générales Mutuelle.pdf',
        id: 'muta-esse-general-terms-v2',
      },
      {
        fileName: 'Orus - IPID Mutuelle.pdf',
        id: 'muta-ipid-v2',
      },
      {
        fileName: 'Orus - Status ACPA.pdf',
        id: 'muta-statuts-asso',
      },
    ],
    PRIVILEGE: [
      {
        fileName: 'Orus - Notice valant Conditions générales Mutuelle.pdf',
        id: 'muta-priv-general-terms-v2',
      },
      {
        fileName: 'Orus - IPID Mutuelle.pdf',
        id: 'muta-ipid-v2',
      },
      {
        fileName: 'Orus - Status ACPA.pdf',
        id: 'muta-statuts-asso',
      },
    ],
  },
}
